<template>
  <div>
    <b-form-row class="align-items-center px-50 justify-content-between">
      <h4>محافظات تنفيذ المشروع</h4>
    </b-form-row>
    <b-form-row>
      <b-col cols="12">
        <hr />
      </b-col>
      <b-col cols="12">
        <b-list-group class="rounded border">
          <b-list-group-item class="bg-secondary bg-lighten-3">
            <b-form-row class="text-white">
              <b-col> محافظة التنفيذ</b-col>
              <b-col> منطقة التنفيذ </b-col>
              <b-col> الميزانية المرصودة للمحافظة </b-col>
              <b-col> عدد المستفيدين في المحافظة </b-col>
              <b-col> </b-col>
            </b-form-row>
          </b-list-group-item>
          <template v-if="loadingRecords">
            <div class="text-center text-info my-2">
              <b-spinner class="align-middle mx-2"></b-spinner>
              <strong>جاري التحميل...</strong>
            </div>
          </template>
          <template v-else>
            <template v-if="records.length === 0 && !isAdding">
              <span class="text-center my-1" style="opacity: 0.7"
                >لا يوجد سجلات حتى الآن</span
              >
            </template>
            <b-list-group-item
              v-for="(government, index) in records"
              :key="index"
            >
              <validation-observer
                v-if="isEdit === government.id"
                ref="EditFormValidation"
              >
                <b-form @submit.prevent="onSubmit(index)">
                  <b-form-row>
                    <b-col>
                      <form-select
                        id="exec-gov"
                        ep="v2/selects/governorates"
                        :reduce="(x) => x.id"
                        :getOptionLabel="(x) => x.name_ar"
                        label="محافظة التنفيذ"
                        rules="required"
                        v-model="toAdd.governorate_id"
                        @option:selected="
                          $refs.areasSelect.refreshOptions(
                            `v2/map/governorate-areas/${toAdd.governorate_id}`
                          )
                        "
                      />
                    </b-col>
                    <b-col>
                      <form-select
                        rules="required"
                        label="منطقة التنفيذ"
                        id="areas"
                        :getOptionLabel="(x) => x.name_ar"
                        :reduce="(x) => x.id"
                        :ep="`v2/map/governorate-areas/${toAdd.governorate_id}`"
                        v-model="toAdd.area_id"
                      />
                    </b-col>

                    <b-col>
                      <form-currency
                        label="الميزانية المرصودة للمحافظة"
                        rules="required"
                        v-model="toAdd.expected_budget"
                      />
                    </b-col>
                    <b-col>
                      <form-cleave
                        label="عدد المستفيدين في المحافظة"
                        rules="required"
                        id="id-num"
                        v-model="toAdd.ben_number"
                        :raw="false"
                        :options="{
                          blocks: [15],
                          numericOnly: true,
                          delimiter: '',
                        }"
                      />
                    </b-col>

                    <b-col
                      class="justify-content-end d-flex pt-50 align-items-center"
                    >
                      <b-button
                        @click="isEdit = null"
                        variant="flat-secondary  "
                        class="mx-50"
                      >
                        إلغاء
                      </b-button>
                      <loader-btn
                        :loading="working"
                        variant="primary"
                        type="submit"
                      >
                      </loader-btn>
                    </b-col>
                  </b-form-row>
                </b-form>
              </validation-observer>
              <b-form-row v-else class="align-items-center">
                <b-col> {{ government.governorate.name_ar }}</b-col>
                <b-col> {{ government.area.name_ar }} </b-col>
                <b-col>
                  {{
                    new Intl.NumberFormat().format(government.expected_budget)
                  }}
                </b-col>
                <b-col> {{ government.ben_number }} </b-col>

                <b-col class="justify-content-end d-flex">
                  <b-button
                    @click="editGov(government)"
                    variant="flat-primary"
                    class="btn-icon rounded-circle"
                  >
                    <feather-icon icon="EditIcon" />
                  </b-button>
                  <b-button
                    @click="onDeleteClicked(government.id)"
                    variant="flat-danger"
                    class="btn-icon rounded-circle"
                  >
                    <feather-icon icon="Trash2Icon" />
                  </b-button>
                </b-col>
              </b-form-row>
            </b-list-group-item>
            <b-list-group-item v-if="isAdding">
              <validation-observer ref="FormValidation">
                <b-form @submit.prevent="onSubmit">
                  <b-form-row>
                    <b-col>
                      <form-select
                        id="exec-gov"
                        ep="v2/selects/governorates"
                        :reduce="(x) => x.id"
                        :getOptionLabel="(x) => x.name_ar"
                        label="محافظة التنفيذ"
                        rules="required"
                        v-model="toAdd.governorate_id"
                        @option:selected="
                          $refs.areasSelect.refreshOptions(
                            `v2/map/governorate-areas/${toAdd.governorate_id}`
                          )
                        "
                      />
                    </b-col>

                    <b-col>
                      <form-select
                        rules="required"
                        label="منطقة التنفيذ"
                        id="areasSelect"
                        :getOptionLabel="(x) => x.name_ar"
                        :reduce="(x) => x.id"
                        ep="v2/map/governorate-areas/1"
                        v-model="toAdd.area_id"
                        ref="areasSelect"
                    /></b-col>

                    <b-col>
                      <form-currency
                        label="الميزانية المرصودة للمحافظة"
                        rules="required"
                        v-model="toAdd.expected_budget"
                      />
                    </b-col>
                    <b-col>
                      <form-cleave
                        label="عدد المستفيدين في المحافظة"
                        rules="required"
                        id="id-num"
                        v-model="toAdd.ben_number"
                        :raw="false"
                        :options="{
                          blocks: [15],
                          numericOnly: true,
                          delimiter: '',
                        }"
                      />
                    </b-col>
                    <b-col
                      class="justify-content-end d-flex pt-50 align-items-center"
                    >
                      <b-button
                        @click="isAdding = false"
                        variant="flat-secondary  "
                        class="mx-50"
                      >
                        إلغاء
                      </b-button>
                      <loader-btn
                        :loading="working"
                        variant="primary"
                        type="submit"
                      >
                      </loader-btn>
                    </b-col>
                  </b-form-row>
                </b-form>
              </validation-observer>
            </b-list-group-item>
          </template>
        </b-list-group>
        <b-form-row class="px-50 mt-1 d-flex justify-content-end">
          <b-button @click="onNewClicked" variant="success">
            <feather-icon icon="PlusIcon" />
            <span> إضافة </span>
          </b-button>
        </b-form-row>
      </b-col>
    </b-form-row>
  </div>
</template>

<script>
import {
  BButton,
  BFormGroup,
  BSpinner,
  BListGroup,
  BListGroupItem,
  BFormRow,
  BCol,
  BForm,
} from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import FormInput from "@/components/form-input";
import FormSelect from "@/components/form-select";
import FormAutocomplete from "@/components/form-autocomplete";
import FormDatepicker from "@/components/form-datepicker";
import FormCleave from "@/components/FormCleave.vue";
import LoaderBtn from "@/components/loader-btn.vue";
import tableEditMixin from "../mixins/TableEditMixin";
import FormCurrency from "@/components/FormCurrency.vue";

export default {
  mixins: [tableEditMixin],
  components: {
    FormInput,
    BButton,
    BFormGroup,
    BSpinner,
    BListGroup,
    BListGroupItem,
    BFormRow,
    BCol,
    LoaderBtn,
    BForm,
    ValidationObserver,
    FormAutocomplete,
    FormSelect,
    FormDatepicker,
    FormCleave,
    FormCurrency,
  },
  data() {
    return {};
  },
  methods: {
    editGov(gov) {
      var mappedGov = { ...gov };
      mappedGov.area_id = gov.area ? gov.area.id : null;
      mappedGov.governorate_id = gov.governorate ? gov.governorate.id : null;
      delete mappedGov.area;
      delete mappedGov.governorate;
      this.onEditClicked(mappedGov);
    },
  },
  computed: {
    fetchEndpoint() {
      return `v2/co-op/project/${this.$route.params.id}/governorates`;
    },
    operationsEndpoint() {
      return `v2/co-op/project/governorates`;
    },
  },
};
</script>
